<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div v-if="ekYetkiler == 'magaza' || ekYetkiler == 'admin'">
      <b-row>
        <b-col cols="12">
          <vs-card>
            <div slot="header">
              <h3>Mağaza Görev Listesi</h3>
            </div>
            <ag-grid-vue
              style="width: 100%; height: 400px; margin-top: 25px"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowdata"
              :localeText="localeText"
              @grid-ready="onGridReady"
              @first-data-rendered="onFirstDataRendered"
              :rowSelection="rowSelection"
            >
            </ag-grid-vue>
          </vs-card>
        </b-col>
      </b-row>
    </div>
    <div v-if="ekYetkiler != 'magaza'">
      <b-row>
        <b-col lg="8" sm="12">
          <b-row>
            <b-col cols="4">
              <statistics-card-line
                style="height: 170px"
                icon="UserMinusIcon"
                :statistic="formatbekleyen"
                statisticTitle="Bekleyen"
                :chartData="subscribersGained.series"
                type="area"
                color="danger"
              />
            </b-col>
            <b-col cols="4">
              <statistics-card-line
                style="height: 170px"
                icon="UserCheckIcon"
                :statistic="formatbiten"
                statisticTitle="Biten"
                :chartData="revenueGenerated.series"
                color="success"
                type="area"
              />
            </b-col>
            <b-col cols="4">
              <statistics-card-line
                class="mb-base"
                style="height: 170px"
                icon="ShoppingCartIcon"
                :statistic="formatTotalSale"
                statisticTitle="Toplam Satış"
                :chartData="quarterlySales.series"
                type="area"
              />
            </b-col>
            <b-col cols="6">
              <vx-card>
                <chartjs-component-line-chart
                  :height="250"
                  :data="aylikSatisData"
                  :chartData="aylikSatisData"
                  :options="aylikSatisOptions"
                ></chartjs-component-line-chart>
              </vx-card>
            </b-col>

            <b-col cols="6">
              <vx-card title="">
                <chartjs-component-line-chart
                  :height="250"
                  :data="pazaryeriAylikSatislarData"
                  :chartData="pazaryeriAylikSatislarData"
                  :options="pazaryeraylikSatisOptions"
                ></chartjs-component-line-chart>
              </vx-card>
            </b-col>
          </b-row>
        </b-col>

        <b-col lg="4" sm="12" style="text-align: -webkit-center">
          <b-row>
            <vx-card>
              <chartjs-component-doughnut-chart
                style="position: relative"
                :height="250"
                :data="pazaryeriData"
                :chartData="pazaryeriData"
                :options="options"
              ></chartjs-component-doughnut-chart>
            </vx-card>
            <vx-card title="" style="margin-top: 15px">
              <chartjs-component-horizontal-bar-chart
                :height="250"
                :data="illerData"
                :chartData="illerData"
                :options="illerOptions"
              ></chartjs-component-horizontal-bar-chart>
            </vx-card>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import vSelect from "vue-select";
import state from "../store/state";
import Store from "../store/store";
import NotificationDropDown from "../layouts/components/navbar/components/NotificationDropDown.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import ChartjsComponentDoughnutChart from "./charts-components/ChartjsComponentDoughnutChart.vue";
import ChartjsComponentLineChart from "./charts-components/ChartjsComponentLineChart.vue";
import ChartjsComponentHorizontalBarChart from "./charts-components/ChartjsComponentHorizontalBarChart.vue";
import MagazaGorevDetayButon from "./components/uzum-components/MagazaGorevDetayButon.vue";
import MagazaGuncellePrompt from "./components/uzum-components/MagazaGuncellePrompt.vue";
import { Filler } from "chart.js";

export default {
  data() {
    return {
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      localeText: null,
      columnDefs: null,
      siparisR: "",
      magazaSecilen: "",
      magazaList: [],
      magazaKodSecilen: "",
      activePrompt: false,
      checkSelected: [],
      pageLength: 50,
      dir: false,

      validated: true,
      formatbekleyen: 0.0,
      formatbiten: 0.0,
      formatTotalSale: 0.0,
      quarterlySales: {
        series: [
          {
            name: "Toplam Satış",
            data: [10, 15, 7, 12, 3, 16],
          },
        ],
      },
      ordersRecevied: {
        series: [
          {
            name: "Orders",
            data: [10, 15, 8, 15, 7, 12, 8],
          },
        ],
      },
      options: {
        hover: { mode: null },
        title: {
          display: true,
          text: "Pazaryerlerine göre yıllık satış adedi",
        },
      },
      aylikSatisData: {},
      pazaryeraylikSatisOptions: {
        title: {
          display: true,
          text: "Pazaryerlerine göre aylık satış adedi",
        },
      },
      aylikSatisOptions: {
        title: {
          display: true,
          text: "Aylık toplam satışlar",
        },
      },
      illerData: {},
      illerOptions: {
        hover: { mode: null },

        legend: { display: false },
        title: {
          display: true,
          text: "İllere göre satış oranı",
        },
      },
      pazaryeriData: {},
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      revenueComparisonLine: {},
      goalOverview: {},

      browserStatistics: [],
      clientRetentionBar: {},

      sessionsData: {},
      chatLog: [],
      chatMsgInput: "",
      customersData: {},

      analyticsData,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      colorPack: [
        "#7dcea0",
        " #808b96",
        " #d98880 ",
        " #f8c471 ",
        " #a9dfbf ",
        "#28C76F",
        "#EA5455",
        "#7dcea0",
        "#ff5733 ",
        " #cd6155 ",
        "#0e6655",
        "#FF9F43",
        "#bb8fce",
        "#f5b7b1",
        "#e67e22",
        "#5d6d7e ",
        "#c39bd3",
        "#5499c7 ",
        " #d4ac0d ",
        " #2ecc71",
        " #85c1e9 ",
        "#7367F0",
      ],
      bekleyen: 0,
      biten: 0,
      data: [],
      pazaryeriAd: [],
      satisAdet: [],
      totalSale: 0.0,
      formatTotalSale: 0.0,
      illerLabel: [],
      illerSatisAdet: [],
      aylar: [],
      pazaryeriAylar: [],
      aylikSatis: [],
      pazaryeriAylikSatislarData: {},
      yilGruplama: [],
      yilGruplama2: [],
      gruplananYillikCek: [],
      gruplananPazaryerleriCek: [],
      ekYetkiler: "",
      tamamlananList: [],
    };
  },
  components: {
    MagazaGorevDetayButon,
    MagazaGuncellePrompt,
    AgGridVue,
    "v-select": vSelect,
    ChartjsComponentHorizontalBarChart,
    VueApexCharts,
    ChartjsComponentLineChart,
    StatisticsCardLine,
    ChartjsComponentDoughnutChart,
    NotificationDropDown,
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
  },
  methods: {
    IdeasoftFirmaUrlKontrol() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.IdeasoftFirmaUrl(args, function (err, result) {
          if (result.IdeasoftFirmaUrlResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.IdeasoftFirmaUrlResult);
          var deger = "true";
          vm.$store.commit("uzum/IDEASOFT_FIRMA_VAL", deger);
          vm.$store.commit("uzum/IDEASOFT_FIRMA_URL", vm.veriler.url);

          vm.autorizeIdeasoft();
        });
      });
    },

    autorizeIdeasoft() {
      var vm = this;
      var urlToken = "http://chirpy.uzum.com.tr/idea.php";
      if (Store.state.uzum.IdeasoftFirmaVal == "true") {
        urlToken = Store.state.uzum.IdeasoftFirmaUrl;
      }
      axios
        .get(urlToken)
        .then((response) => {
          document.getElementById("frm").src = url;
        })
        .catch((e) => {
          //  alert("ss")
          //  document.getElementById("frm").src=url
          //              this.popupActiveCikti=true
          // document.getElementById("frm").src=url
          window.open(urlToken);
          /*  setTimeout(function () {
            vm.siparisCekZamanli(sayfasayisi);
          }, 3500);*/
        });
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    rowStyleClassFn(row) {
      return "VGT-row";
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    parseDateVal(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    siparisDetay(data, ref) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        siparisRef: ref,
      };
      soap.createClient(url, function (err, client) {
        client.magazaGorevListesiDetay(args, function (err, result) {
          if (result.magazaGorevListesiDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.magazaGorevListesiDetayResult);
          vm.$refs.siparisCek.siparisDetayCek(data, vm.veriler.jsonData);
        });
      });
    },
    siparisListesi() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        gorevyeri: Store.state.sube,
        gorev: Store.state.ekYetkiler,
      };

      soap.createClient(url, function (err, client) {
        client.magazaGorevListesi(args, function (err, result) {
          if (result.magazaGorevListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.magazaGorevListesiResult);
            if ((vm.veriler.response = "Ok")) {
              vs.notify({
                title: "Mağaza",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              vm.tamamlananList = vm.veriler.jsonData;
              vm.rowdata = vm.veriler.jsonData;
            } else {
              vs.notify({
                title: "Mağaza",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {}
        });
      });
    },
    illerSatis() {
      var vm = this;
      vm.veriler = [];

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.dbSatisYapilanIller(args, function (err, result) {
          if (result.dbSatisYapilanIllerResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.illerData = Object.assign({});
              vm.$set(vm.illerData, "labels", []);
              vm.$set(vm.illerData, "datasets", []);
              var resultBG = [];
              vm.veriler = JSON.parse(result.dbSatisYapilanIllerResult);

              vm.veriler.forEach((value, index) => {
                vm.illerLabel.push(vm.veriler[index].Sehir);
                vm.illerSatisAdet.push(vm.veriler[index].satisAdet);
                resultBG.push(vm.colorPack[index]);
              });
              //alert(vm.totalSale);

              vm.illerData.labels = vm.illerLabel;
              vm.illerData.datasets.push({
                data: vm.illerSatisAdet,
                backgroundColor: resultBG,
                borderWidth: 2,
              });
            } catch (error) {}
          }
        });
      });
    },
    aylikSatislar() {
      var vm = this;
      vm.veriler = [];

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { token: Store.state.tokenId };

      soap.createClient(url, function (err, client) {
        client.dbAylikSatislar(args, function (err, result) {
          if (result.dbAylikSatislarResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.aylikSatisData = Object.assign({});
              vm.$set(vm.aylikSatisData, "labels", []);
              vm.$set(vm.aylikSatisData, "datasets", []);

              vm.veriler = JSON.parse(result.dbAylikSatislarResult);

              function monthName(mon) {
                return [
                  "Ocak",
                  "Şubat",
                  "Mart",
                  "Nisan",
                  "Mayıs",
                  "Haziran",
                  "Temmuz",
                  "Ağustos",
                  "Eylül",
                  "Ekim",
                  "Kasım",
                  "Aralık",
                ][mon - 1];
              }
              vm.veriler.forEach((value, index) => {
                vm.aylar.push(monthName(vm.veriler[index].AY));

                vm.aylikSatis.push(vm.veriler[index].Adet);
              });

              vm.aylikSatisData["labels"] = vm.aylar;
              vm.aylikSatisData.datasets.push({
                label: "Aylık satış (adet)",
                data: vm.aylikSatis,
                borderColor: "#7367F0",
                borderWidth: 2,
              });
            } catch (error) {}
          }
        });
      });
    },
    //doughnut chart
    fillData() {
      var vm = this;
      vm.veriler = [];

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { token: Store.state.tokenId };

      soap.createClient(url, function (err, client) {
        client.dbPazaryerDagilim(args, function (err, result) {
          if (result.dbPazaryerDagilimResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.pazaryeriData = Object.assign({});
              vm.$set(vm.pazaryeriData, "labels", []);
              vm.$set(vm.pazaryeriData, "datasets", []);
              var resultBG = [];
              vm.veriler = JSON.parse(result.dbPazaryerDagilimResult);

              vm.veriler.forEach((value, index) => {
                vm.pazaryeriAd.push(vm.veriler[index].program);
                vm.satisAdet.push(vm.veriler[index].Adet);
                vm.totalSale += vm.veriler[index].Adet;
                resultBG.push(vm.colorPack[index]);
              });
              vm.formatTotalSale = new Intl.NumberFormat().format(vm.totalSale);
              //alert(vm.totalSale);

              vm.pazaryeriData.labels = vm.pazaryeriAd;
              vm.pazaryeriData.datasets.push({
                data: vm.satisAdet,
                backgroundColor: resultBG,
                borderWidth: 2,
              });
            } catch (error) {}
          }
        });
      });
    },
    satislar() {
      var vm = this;
      vm.veriler = [];

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.dashBoard(args, function (err, result) {
          if (result.dashBoardResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.veriler = JSON.parse(result.dashBoardResult);
              vm.bekleyen = vm.veriler.bekleyen;
              vm.formatbekleyen = new Intl.NumberFormat().format(vm.bekleyen);
              vm.biten = vm.veriler.biten;
              vm.formatbiten = new Intl.NumberFormat().format(vm.biten);
            } catch (error) {}
          }
        });
      });
    },
    ayaGorePazaryerleriSatis() {
      var vm = this;
      var eklenmisDate = [];
      var vadeDate = [];
      vm.veriler = [];
      vm.yilGruplama = [];
      vm.yilGruplama2 = [];
      vm.yilLabel = [];
      vm.orderYear = [];
      vm.ayDataSet = [];
      vm.aySeti = [];
      vm.pazaryeriAdlari = [];

      vm.adetData = [];
      vm.adetSeti = [];

      vm.pazaryerleriGruplama;
      vm.pazaryeriAylik = [];
      vm.gruplananYillikCek = [];
      vm.gruplananPazaryerleriCek = [];

      vm.pazaryeriAdGrubu = [];
      vm.gruplananPazaryerleriCek2 = [];

      vm.dataSet = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.dbPazaryeriAylikSatislar(args, function (err, result) {
          if (result.dbPazaryeriAylikSatislarResult == "-1") {
            Store.dispatch("logout");
          } else {
            try {
              vm.pazaryeriAylikSatislarData = Object.assign({});
              vm.$set(vm.pazaryeriAylikSatislarData, "labels", []);
              vm.$set(vm.pazaryeriAylikSatislarData, "datasets", []);
              vm.veriler = JSON.parse(result.dbPazaryeriAylikSatislarResult);

              vm.veriler.sort(function (a, b) {
                return new Date(a.YILAY) - new Date(b.YILAY);
              });

              vm.yilGruplama = _.groupBy(vm.veriler, (veri) =>
                JSON.stringify({ YILAY: veri.YILAY })
              );
              const gruplanmisYillarListesi = Object.keys(vm.yilGruplama);
              gruplanmisYillarListesi.forEach((key, i) => {
                var pazaryeriyillar = vm.yilGruplama[key];
                vm.gruplananYillikCek.push(pazaryeriyillar);
              });
              vm.gruplananYillikCek.forEach((value, index) => {
                vm.yilGruplama2.push({
                  adet: vm.gruplananYillikCek[index][0].Adet,
                  program: vm.gruplananYillikCek[index][0].program,
                  date: vm.gruplananYillikCek[index][0].YILAY,
                });
                vm.yilLabel.push(vm.gruplananYillikCek[index][0].YILAY);
              });

              //pazaryerlerine göre gruplama
              vm.pazaryerleriGruplama = _.groupBy(vm.veriler, (veri) =>
                JSON.stringify({ program: veri.program })
              );
              const gruplanmisPazaryerleriListesi = Object.keys(vm.pazaryerleriGruplama);
              gruplanmisPazaryerleriListesi.forEach((key, i) => {
                var yillikPazaryerleri = vm.pazaryerleriGruplama[key];
                vm.gruplananPazaryerleriCek.push(yillikPazaryerleri);
              });
              vm.gruplananPazaryerleriCek.forEach((value, index) => {
                vm.gruplananPazaryerleriCek2.push({
                  adet: vm.gruplananPazaryerleriCek[index][0].Adet,
                  program: vm.gruplananPazaryerleriCek[index][0].program,
                  date: vm.gruplananPazaryerleriCek[index][0].YILAY,
                });
              });
              var resultBG = [];
              var pazaryeriYil = [];
              var pazaryeriyilToplu = [];

              for (var i = 0; i < vm.gruplananPazaryerleriCek.length; i++) {
                vm.adetDataSet = [];
                pazaryeriYil = [];
                resultBG.push(vm.colorPack[i + 1]);
                for (var j = 0; j < vm.gruplananPazaryerleriCek[i].length; j++) {
                  for (var k = 0; k < vm.yilGruplama2.length; k++) {
                    if (
                      vm.yilGruplama2[k].date == vm.gruplananPazaryerleriCek[i][j].YILAY
                    ) {
                      pazaryeriYil.push(vm.gruplananPazaryerleriCek[i][j].Adet);
                      j++;
                    } else if (
                      vm.yilGruplama2[k].date != vm.gruplananPazaryerleriCek[i][j].YILAY
                    ) {
                      pazaryeriYil.push(0);
                    }
                  }
                  //  vm.adetDataSet.push(vm.gruplananPazaryerleriCek[i][j].Adet);
                }
                pazaryeriyilToplu.push(pazaryeriYil);
                //   vm.adetData.push(vm.adetDataSet);
                vm.pazaryeriAdGrubu.push(vm.gruplananPazaryerleriCek[i][0].program);
              }

              vm.pazaryeriAylikSatislarData["labels"] = vm.yilLabel;
              vm.pazaryeriAdGrubu.forEach((value, index) => {
                vm.pazaryeriAylikSatislarData.datasets.push({
                  label: vm.pazaryeriAdGrubu[index],
                  data: pazaryeriyilToplu[index],
                  borderColor: resultBG[index],
                  borderWidth: 2,
                  showLine: true,
                  fill: false,
                });
              });
            } catch (error) {}
          }
        });
      });
    },
    satisAdetFonk() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.selectIslemTipi)
      const args = {};
      /*soap.createClient(url, function(err, client){
        client.dashBoardCokSatan(args, function(err, result){
        vm.veriler=JSON.parse(result.dashBoardCokSatanResult)
        vm.data=vm.veriler
      })
      })*/
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("magazagorevlist", () => {
      this.siparisListesi();
    });
  },
  beforeDestroy() {
    this.$root.$off("magazagorevlist");
  },
  created() {
    if (Store.state.uzum.IdeasoftFirmaVal == "true") {
      this.IdeasoftFirmaUrlKontrol();
    }
    this.rowSelection = "single";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.siparisListesi();
    this.ekYetkiler = Store.state.ekYetkiler;
    var vm = this;
    vm.ayaGorePazaryerleriSatis();
    vm.fillData();
    vm.satislar();
    vm.aylikSatislar();
    vm.illerSatis();
    var d = new Date(vm.baslangic);
    vm.formattedDate =
      d.getUTCDate() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCFullYear();

    var d1 = new Date(vm.bitis);
    vm.formattedDate1 =
      d1.getUTCDate() + "/" + (d1.getUTCMonth() + 1) + "/" + d1.getUTCFullYear();

    const soap = require("soap");
    const url = state.sistemAddress;
    // alert(this.selectIslemTipi)
    const args = {};
    /* soap.createClient(url, function(err, client){
        client.dashBoard(args, function(err, result){
        vm.veriler=JSON.parse(result.dashBoardResult)
        if (vm.veriler.response=='Ok') {
            vm.bekleyen=vm.veriler.bekleyen
            vm.biten=vm.veriler.biten
            vm.satisAdet()
        } else {
        
        }
      })
      })*/
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "invoiceFirstName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Kod",
        field: "cariKod",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Depo Kodu",
        field: "depoKodu",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Kodu",
        field: "cargoTrackingNumber",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Adı",
        field: "cargoName",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Mağaza Kodu",
        field: "magazaKodu",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        editable: true,
        cellEditorPopup: true,
        cellEditorSelector: (params) => {
          return {
            component: "MagazaGuncellePrompt",
            popup: true,
          };
        },
      },
      {
        headerName: "Şube",
        field: "sube",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Pazaryeri",
        field: "pazaryeri",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Tarihi",
        field: "siparisTarihi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDateVal,
      },
      {
        width: 100,
        field: "",
        cellRendererFramework: "MagazaGorevDetayButon",
      },
    ];
  },
};
</script>

<style lang="scss">
.chartjs-render-monitor {
  height: 100% !important;
  max-width: 700px !important;
}
table.vgt-table {
  font-size: 13px;
}
[dir] .vgt-table.bordered td,
[dir] .vgt-table.bordered th {
  text-align: center;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 11px;
}
</style>
